import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle, Button, Box} from 'views/components';
import {TextCharLimit} from 'views/components';
import {Translate, translate} from 'views/module';

const ClientNameEdit = (props) => {
  const [newValue, setNewValue] = React.useState('');

  const {
    clientData,
    clientBackend,
    isEditing,
    setIsEditing,
  } = props;

  const {clientName} = clientData;

  React.useEffect(() => {
    setNewValue(clientName);
  }, [clientName]);

  const onSave = () => {
    clientBackend.detail.editName(newValue, () => {
      setIsEditing(false);
    });
  };

  const isValid = () => {
    return !Boolean(newValue);
  };

  const onClose = () => {
    setIsEditing(false);
  };

  return (
    <Dialog onClose={onClose} open={isEditing}>
      <DialogTitle onClose={onClose}>
        <Translate expression='client.ClientDetail.ChangeName.Title' />
      </DialogTitle>
      <DialogContent>
        <Box sx={{m: 1}}>
          <TextCharLimit
            label={translate('client.ClientDetail.ChangeName.ClientName')}
            value={newValue}
            onChange={setNewValue}
            charLimit={180}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="primary" disabled={isValid()} onClick={onSave}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ClientNameEdit.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientNameEdit);
